<template>
  <div>
    <table class="fac-purpose">
      <tbody>
        <tr v-for="(eventTypeLabel, index) in eventTypeLabels" :key="index">
          <th>{{ eventTypeLabel[0].label }}</th>
          <td>
            <span v-for="(eventType, index2) in eventTypeLabel" :key="index2">
              <kcs-event-type-label :content="eventType.name" />
            </span>
          </td>
        </tr>
      </tbody>
    </table>

    <ul class="fac-appointments">
      <li v-for="(name, index) in serviceList" :key="index">
        <kcs-service :service="name" />
      </li>
    </ul>
    <kcs-ads-facility-icons-bottom />
    <kcs-btn
      v-if="!$device.isMobile"
      :url="detail.url"
      :external="true"
      @click.native="
        handleAnalyticsTrackEvent(
          'facility_detail',
          'click',
          'official_link',
          1
        )
      "
      name="公式ホームページ"
    />
    <div v-if="isDisplayTicketArea" class="ticket-link">
      <kcs-btn
        v-if="!$device.isMobile"
        :url="ticketUrl"
        :external="true"
        @click.native="
          handleAnalyticsTrackEvent(
            'facility_detail',
            'click',
            'ticket_link',
            1
          )
        "
        name="チケット販売情報"
      />
    </div>
    <kcs-facility-contact :detail="detail" v-if="$device.isMobile" />
    <kcs-facility-ticket
      :detail="detail"
      v-if="$device.isMobile && isDisplayTicketArea"
    />
    <kcs-event-regist :detail="detail" v-if="$device.isMobile" />
  </div>
</template>

<script>
import { methods } from '@/utils/methods'
import KcsEventTypeLabel from '@/components/atoms/kcs-event-type-label.vue'
import KcsService from '@/components/atoms/kcs-service.vue'
import KcsBtn from '@/components/atoms/kcs-btn.vue'
import KcsFacilityContact from '@/components/molecules/kcs-facility-contact.vue'
import KcsFacilityTicket from '@/components/molecules/kcs-facility-ticket.vue'
import KcsEventRegist from '@/components/molecules/kcs-event-regist.vue'
import KcsAdsFacilityIconsBottom from '@/components/molecules/kcs-ads-facility-icons-bottom.vue'
export default {
  components: {
    KcsEventTypeLabel,
    KcsService,
    KcsBtn,
    KcsFacilityContact,
    KcsFacilityTicket,
    KcsEventRegist,
    KcsAdsFacilityIconsBottom
  },
  props: {
    detail: {
      type: Object,
      required: true
    }
  },
  computed: {
    // イベント規模・種類マスタを整形 [1,2] => [{name: "大", code: 11}]
    eventTypeLabels() {
      return methods.formatFacilityEventTypesList(this.detail.event_type)
    },
    // 設備・サービスアイコンマスタを整形 [11,12] => ['catering', 'coinlocker']
    serviceList() {
      return methods.formatServiceList(this.detail.service)
    },
    ticketUrl() {
      return (
        'https://click.linksynergy.com/deeplink?id=zQNBiDvaWU0&mid=36672&murl=' +
        this.$options.filters.urlencode(
          'https://md-search.pia.jp/pia/venue/venue.do?venueCd=' +
            this.detail.pia
        )
      )
    },
    isDisplayTicketArea() {
      return this.detail.pia
    }
  }
}
</script>
